const routes = {
  getPermissions: 'permission/',
  createPermission: 'permission/',
  updatePermission: 'permission/:permission_id',
  deletePermission: 'permission/:permission_id'
};

export default routes;